<template>
  
  <div class="ui segment">

    <div :id="_uid" class="ui fluid accordion">  

      <h4 :id="_uid + '_title'" class="ui dividing header title">
        <i class="dropdown icon"></i>Filtros
      </h4>

      <div class="content active">
        <div class="ui form">
          <div class="fields">
            <div class="three wide field">
              <label class="form-label">Vencimento Inicial <span class="red text">*</span></label>
              <date-picker ref="startDueDatePicker" @onChange="onChangeStartDueDate" />
            </div>
            <div class="three wide field">
              <label class="form-label">Vencimento Final <span class="red text">*</span></label>
              <date-picker ref="endDueDatePicker" @onChange="onChangeEndDueDate" />
            </div>
            <div class="five wide field">
              <label class="form-label">Cliente</label>
              <input v-model="filter.customerName">
            </div>
            <div class="five wide field">
              <label class="form-label">Status</label>
              <select-dropdown ref="statusDropdown" @onChange="onChangeStatus" />
            </div>
          </div>          
        </div>  
        <button class="ui blue button m-t-10" @click="onApply()">
          <i class="check icon"></i> Aplicar
        </button>
      </div>

    </div>

  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import ReceivableService from "@/services/receivable-service"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "ReceivablesSettlesFilter",

    data() {
      return {
        filter: {},
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
    },

    mounted() {
      
      $(`#${this._uid}`).accordion()

      this.loadStatusDropdown()
    },

    methods: {

      loadStatusDropdown() {

        let values = [{ id: "*", value: '<i class="asterisk icon"></i> Todos' }]
        const statusList = ReceivableService.getStatusList()
        
        for (let status of statusList) {
          values.push(status)
        }

        this.$refs.statusDropdown.setValues(values)
      },

      onChangeStartDueDate(date) {
        this.filter.startDueDate = date
        this.refreshData()          
      },

      onChangeEndDueDate(date) {
        this.filter.endDueDate = date
        this.refreshData()          
      },

      onChangeStatus(id) {
        this.filter.status = id
        this.refreshData()
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },

      onApply() {

        if (!this.validFilter())
          return

        $(`#${this._uid}_title`).click()

        this.$emit("onApply", this.$cloneObject(this.filter))
      },

      validFilter() {

        if (!this.filter.startDueDate || !this.filter.endDueDate) {
          this.$msg.info("Informe o intervalo de vencimentos")
          return false
        }

        if (moment(this.filter.startDueDate).format("YYYYMMDD") > moment(this.filter.endDueDate).format("YYYYMMDD")) {
          this.$msg.info("A data inicial não pode ser maior que a data final")
          return false
        }

        return true
      },
    },
  }

</script>